import React from 'react';
import { CreditCard } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// GF du carnet utilisables à une date : le week-end, les GF des carnets « semaine » ne comptent pas
export const gfCarnetUsable = (ps, date) => {
  const rem = Number(ps?.green_fee_carnet_remaining || 0);
  const wk = Math.min(Number(ps?.green_fee_carnet_weekday_remaining || 0), Math.max(rem, 0));
  const d = date ? new Date(date).getDay() : new Date().getDay();
  return d === 0 || d === 6 ? rem - wk : rem;
};

// Solde après décompte de n GF à une date (en semaine, les GF « semaine » partent en premier)
export const gfCarnetAfterUse = (ps, remaining, used, date) => {
  const wk = Math.min(Number(ps?.green_fee_carnet_weekday_remaining || 0), Math.max(Number(ps?.green_fee_carnet_remaining || 0), 0));
  const d = new Date(date).getDay();
  const weekend = d === 0 || d === 6;
  return { ...ps, green_fee_carnet_remaining: remaining, green_fee_carnet_weekday_remaining: weekend ? wk : Math.max(0, wk - used) };
};

// Carnets GF en vente dans l'espace club : ceux de la page Tarifs › Carnets GF, à leur prix
export const GfCarnetPacks = ({ packs, token, onTrack }) => {
  if (!packs?.length) return <p className="text-xs text-neutral-500 px-1" data-testid="gf-packs-empty">Aucun carnet en vente pour le moment.</p>;
  const buy = async (p) => {
    onTrack?.(p);
    try {
      const res = await fetch(`${API_URL}/api/tee-times/portal/buy-carnet`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ pack_id: p.id }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail);
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(e.message); }
  };
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="gf-packs-grid">
      {packs.map((p) => (
        <Card key={p.id} className="overflow-hidden cursor-pointer hover:shadow-md transition-shadow" onClick={() => buy(p)} data-testid={`buy-carnet-${p.id}`}>
          <CardContent className="p-3 text-center flex flex-col h-full">
            <p className="font-bold text-sm leading-tight" style={{ color: '#2E6A4C' }}>{p.name}</p>
            <p className="text-[11px] text-neutral-500 mt-0.5">{p.count} Green Fees</p>
            {p.weekdays_only && <p className="text-[10px] font-semibold text-sky-700 mt-0.5" data-testid={`buy-carnet-weekdays-${p.id}`}>Du lundi au vendredi</p>}
            <p className="font-bold text-lg text-emerald-700 mt-1" data-testid={`buy-carnet-price-${p.id}`}>{p.price} €</p>
            <Button size="sm" className="mt-auto bg-emerald-600 hover:bg-emerald-700 h-7 text-xs w-full">
              <CreditCard size={12} className="mr-1" /> Acheter
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
